import { Flex, Skeleton } from '@percent/lemonade'
import classes from './DonationFormSkeletonLoader.module.scss'

export function DonationFormSkeletonLoader() {
  return (
    <Flex
      direction="column"
      align="stretch"
      gap={0}
      className={classes.donationFormSkeletonContainer}
      data-testid="donationFormLoader"
    >
      <Flex justify="center" style={{ marginBottom: '32px' }}>
        <Skeleton variant="rectangular" width="105px" height={4} style={{ borderRadius: '4px' }} />
      </Flex>
      <Flex direction="row" align="center" gap={12} style={{ marginBottom: '32px' }}>
        <Skeleton variant="rectangular" width={52} height={52} style={{ borderRadius: '100%' }} />
        <Flex direction="column" gap={12}>
          <Skeleton variant="rectangular" width={105} height={16} />
          <Skeleton variant="rectangular" width={65} height={16} />
        </Flex>
      </Flex>
      <Flex direction="column" gap={16} style={{ flexGrow: 1 }}>
        <Skeleton variant="rectangular" width="100%" height={40} style={{ borderRadius: '6px' }} />
        <Flex direction="row" justify="space-between" gap={8}>
          <Skeleton variant="rectangular" width="23%" height={34} style={{ borderRadius: '4px' }} />
          <Skeleton variant="rectangular" width="23%" height={34} style={{ borderRadius: '4px' }} />
          <Skeleton variant="rectangular" width="23%" height={34} style={{ borderRadius: '4px' }} />
          <Skeleton variant="rectangular" width="23%" height={34} style={{ borderRadius: '4px' }} />
        </Flex>
        <Skeleton variant="rectangular" className={classes.inputSkeleton} />
        <Flex direction="row" align="flex-start" gap={12}>
          <Skeleton variant="rectangular" width={16} height={16} style={{ borderRadius: '100%', marginTop: '4px' }} />
          <Skeleton variant="rectangular" width="100%" height="64px" style={{ borderRadius: '4px' }} />
        </Flex>
      </Flex>
      <Skeleton variant="rectangular" className={classes.donateButtonSkeleton} />
    </Flex>
  )
}
